const equipment = {
  title: 'INACTIVAR EQUIPO'
}

export default equipment;
